import { Helmet } from 'react-helmet';
import { useRouteError } from 'react-router-dom';
import { getPath } from '../../config';
import useBodyBackground from '../../hooks/useBodyBackground';
import useContentForBuild from '../../hooks/useContentForBuild';
import './error.sass';

export default function Error() {
  const error = useRouteError();
  useBodyBackground(`url(${getPath('bg_general')}) no-repeat top center fixed #000`);
  console.error(error);
  const [content] = useContentForBuild();

  return (
    <>
      {content && (
        <>
          <Helmet>
            <title>{content.error}</title>
            <meta name="description" content={content.error} />
          </Helmet>
          <div className="error-page">
            <div>
              <h1>{content.error}</h1>
              <p>{content.errorGeneric}</p>
              <small>{JSON.stringify(error)}</small>
            </div>
          </div>
        </>
      )}
    </>
  );
}
